import { ItemPropertyValue } from "../ItemPropertyValue";

export const EnumArrayProperty = ({ value }) => {
    return <ItemPropertyValue value={Array.isArray(value) ? value : null} />;
}
